export default __webpack_public_path__ + "static/media/affiche2013.155c9806.png";